module.exports = __webpack_public_path__ + "img/Metastasis-MELA_SpatialResearch.623a165a.png";